import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./Components/layout.js";
import HomePage from "./Pages/ClientPage/HomePage/HomePage.js";
import ReservationPage from "./Pages/ClientPage/ReservationPage/SearchBar/SearchBar.js";
import Article from "./Pages/ClientPage/Magazin/ArticleGallerie/ArticlesGallery.jsx";
import ArticleDetail from "./Pages/ClientPage/Magazin/ArticleDetail/ArticleDetail.jsx";
import ConfirmationForm from "./Pages/ClientPage/ReservationPage/ConfirmationReservation/ConfirmationForm.jsx";
import AobergeChambrePage from './Pages/ClientPage/AobergePage/aobergeChambrePage.jsx'
import AobergeSuitePage from './Pages/ClientPage/AobergePage/aobergeSuitePage.jsx'
import ConnexionPage from "./Pages/ConnexionPage/AdminLogin.js";
import HomePageAdmin from "./Pages/AdminPage/HomePageAdmin/HomePageAdmin.js";
import GestionDesChambres from "./Pages/AdminPage/GestionDesChambre/GestionDesChambres.js";
import GestionDesReservations from "./Pages/AdminPage/GestionDesReservatios/GestionDesReservations.js";
import NosClients from "./Pages/AdminPage/NosClients/NosClients.js"
import Calculator from "./Pages/AdminPage/Calculator/Calculator.js";
import RedactionArticle from "./Pages/AdminPage/Article/RedactionArticles/ArticleEditeur.jsx";
import EditionArticle from "./Pages/AdminPage/Article/GestionArticles/EditArticles.jsx";
import EditSingleArticle from "./Pages/AdminPage/Article/EditionArticle/EditSingleArticle.js";
import ConditionsGenerales from "./Pages/ClientPage/ReservationPage/ConfirmationReservation/ConditionsGenerales.jsx";
import PaymentFailure from "./Pages/ClientPage/ReservationPage/ConfirmationReservation/PaymentFailure.jsx";
import PaymentSuccess from "./Pages/ClientPage/ReservationPage/ConfirmationReservation/PaymentSuccess.jsx";
import ScrollToTop from './Components/scrollToTop.js';
import AccountActivated from './Pages/ClientPage/ActivateAccount/ActivateAccount.jsx';
import InterfaceClient from './Pages/ClientPage/ActivateAccount/interfaceClient.jsx'
import "./App.css";

function App() {
  const [admin, setAdmin] = useState(null);

  return (
    <Router>
           <ScrollToTop />

      <Routes>
         {/* 🔥 Route indépendante (hors Layout !) */}
    <Route path="/account-activated/:token" element={<AccountActivated />} />
    <Route path="/interfaceClient" element={<InterfaceClient/>}/>


        {/* Toutes les pages passent par Layout */}
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="Connexion" element={<ConnexionPage setAdmin={setAdmin} />} />
          <Route path="AobergeC" element={<AobergeChambrePage />} />
          <Route path="AobergeS" element={<AobergeSuitePage />} />
          <Route path="Reservation" element={<ReservationPage />} />
          <Route path="ConfirmationForm" element={<ConfirmationForm />} />
          <Route path="Article" element={<Article />} />
          <Route path="/articles/:id" element={<ArticleDetail />} />
          <Route path="/conditions-generales" element={<ConditionsGenerales />} />
          <Route path="/PaymentSuccess" element={<PaymentSuccess />} />
          <Route path="/PaymentFailure" element={<PaymentFailure />} />


          
          {/* Routes Admin sécurisées (redirection vers Connexion si pas admin) */}
          <Route path="/HomePageAdmin" element={admin ? <HomePageAdmin setAdmin={setAdmin} /> : <Navigate to="/Connexion" />} />
          <Route path="/GestionDesChambres" element={admin ? <GestionDesChambres /> : <Navigate to="/Connexion" />} />
          <Route path="/GestionDesReservations" element={admin ? <GestionDesReservations /> : <Navigate to="/Connexion" />}/>
          <Route path="/NosClients" element={admin ? <NosClients /> : <Navigate to="/Connexion" />} />
          <Route path="/Calculator" element={admin ? <Calculator /> : <Navigate to="/Calculator" />} />
          <Route path="/RedactionArticle" element={admin ? <RedactionArticle /> : <Navigate to="/RedactionArticle" />} />
          <Route path="/EditionArticle" element={admin ? <EditionArticle /> : <Navigate to="/EditionArticle" />} />
          <Route path="/EditSingleArticle/:id" element={admin ? <EditSingleArticle /> : <Navigate to="/EditSingleArticle" />} />
        
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
